import { computed } from 'vue';

import { getSiteEnv } from '@/utils/env';
import { getArea } from '@/utils/area';

// 合同状态枚举
export const CONTRACT_STATUS = {
  FAIL: 0,
  AUDIT_PENDING: 1,
  EXEC_PENDING: 2,
  EXECUTING: 3,
  FINISH: 4,
};

export const CONTRACT_STATUS_OPTIONS = [
  { value: CONTRACT_STATUS.FAIL, label: $t('审核失败') },
  { value: CONTRACT_STATUS.AUDIT_PENDING, label: $t('待审核') },
  { value: CONTRACT_STATUS.EXEC_PENDING, label: $t('待履行') },
  { value: CONTRACT_STATUS.EXECUTING, label: $t('审核成功') },
  { value: CONTRACT_STATUS.FINISH, label: $t('已完成') },
];

// 合同类型枚举
export const CONTRACT_TYPES = {
  MAIN: 0,
  SUB: 1,
  SUPPLEMENT: 2,
};

export const CONTRACT_TYPE_OPTIONS = [
  { value: CONTRACT_TYPES.MAIN, label: $t('主合同') },
  { value: CONTRACT_TYPES.SUB, label: $t('子合同') },
  { value: CONTRACT_TYPES.SUPPLEMENT, label: $t('补充合同') },
];

// 合同收付类型枚举
export const CONTRACT_PAYMENT_TYPES = {
  PAYMENT: 0,
  RECEIPT: 1,
};

// 通知的优先级对应的TAG类型
export const NOTIFICATION_TYPES = {
  low: 'primary',
  middle: 'warning',
  high: 'danger',
};
export const FORM_DATA_SCHEME_KEYS_MAP = {
  acceptance: [
    'delivery_number',
    'demand_name',
    'supplier_id',
    'org_id',
    'currency_id',
    'category_id',
    'cost_type_id',
    'order_number',
    'flow_node_code',
    'flow_instance_id',
    'agent_uid',
    'accept_time',
    'amount',
    'method',
    'content',
    'creator_uid',
    'documentation_time',
    'is_last_accept',
    'directions',
    'accept_uid',
    'reviewer_uid',
    'parent_reviewer_uid',
    'source',
    'pa_number',
    'pr_number',
    'pr_name',
    'discount_amount',
    'discounted_amount',
    'dept_id',
    'center_dept_id',
    'group_dept_id',
    'total_assessment_score',
    'status',
    'method',
    'directions',
    'delivery_number',
    'delivery_status',
    'quote_template_file_id',
    'quote_type',
  ],
  acceptance_ext: ['acceptance_number', 'description', 'business_reason', 'remark', 'overall_evaluation'],
  acceptance_financial: [
    'acceptance_number',
    'order_number',
    'order_financial_id',
    'category_id',
    'procure_describe',
    'dept_id',
    'dept_name',
    'cost_center_code',
    'cost_center_name',
    'account_item_name',
    'account_item_code',
    'budget_item_name',
    'budget_item_code',
    'product_code',
    'product_name',
    'procure_amount',
    'accept_procure_amount',
    'can_accept_amount',
    'accept_amount',
    'settlement_start_date',
    'settlement_end_date',
    'remark',
  ],
  acceptance_gift: [
    'order_gift_id',
    'acceptance_number',
    'category_id',
    'workload_unit_id',
    'unit_amount',
    'quantity',
    'description',
    'product_name',
  ],
  acceptance_purchase: [
    'delivery_number',
    'order_purchase_number',
    'category_id',
    'workload_unit_id',
    'product_name',
    'quantity',
    'amount',
    'acc_amount',
    'acc_quantity',
    'unit_price',
    'discount_amount',
    'remark',
    'desc',
    'method',
    'produce_grade_id',
    'produce_breakdown_id',
    'delivery_purchase_number',
  ],
  acceptance_supper_review: ['acceptance_number', 'supplier_evaluation_id', 'score', 'weight'],
  upload_file: [
    'name',
    'size',
    'type',
    'url',
    'object_table',
    'object_id',
    'object_type',
    'md5',
    'status',
    'key',
    'object_ids',
  ],
  delivery_upload_file_property: [
    'name',
    'size',
    'type',
    'url',
    'object_table',
    'object_id',
    'object_ids',
    'object_type',
    'md5',
    'status',
    'key',
    'delivery_number',
  ],
};

/**  状态 10:草稿 30:被驳回 40:审批中 50:待接受 60:被接受 70:被拒绝 80 待付款 90 已付款（支付完成）*/
export const STATUS_COLOR = {
  10: { color: '#000000', backgroundColor: '#F3F3F3' },
  30: { color: '#D54B43', backgroundColor: '#FFF0ED' },
  40: { color: '#E37318', backgroundColor: '#FFF1E9' },
  45: { color: '#2BA471', backgroundColor: '#E3F9E9' },
  50: { color: '#F59A23', backgroundColor: '#FEF3E6' },
  60: { color: '#2BA471', backgroundColor: '#E3F9E9' },
  70: { color: '#D54B43', backgroundColor: '#FFF0ED' },
  80: { color: '#2BA471', backgroundColor: '#E3F9E9' },
  90: { color: '#2BA471', backgroundColor: '#E3F9E9' },
};
/** 根据当前SITE_ENV环境映射SSCM域名 */
export const SSCM_DOMAIN = computed(() => {
  if (['dev', 'test'].includes(getSiteEnv())) return 'http://test-ssc.woa.com';
  const sscmDomainMap = {
    cn: 'https://cn-ssc.woa.com',
    ap: 'https://ap-ssc.woa.com',
    na: 'https://na-ssc.woa.com',
    eu: 'https://eu-ssc.woa.com',
  };
  if (getSiteEnv() === 'prod') return sscmDomainMap[getArea()];
  return '';
});

// 菜单的tooltip content
export const CONTENT_MAP = {
  artcool_index: {
    badgeContent: $t('请更新能力展示信息（如作品集、档期状态等）'),
    noBadgeContent: $t(
      '为提升腾讯内部用户对贵公司能力的了解，帮助您获取到更多的需求合作机会，您可在本模块中动态维护和展示您的全面供应能力及作品',
    ),
  },
};
